import { render, staticRenderFns } from "./ResetPasswordAnimation.vue?vue&type=template&id=27c2a5f6&scoped=true&"
import script from "./ResetPasswordAnimation.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordAnimation.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-animation.scss?vue&type=style&index=0&id=27c2a5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2a5f6",
  null
  
)

export default component.exports